import type { PatientGoalDetail } from '../../services/api/types.gen';

/**
 * The date a goal was met or found unattainable: the date of the visit it was
 * closed on. Only a completion with no visit falls back to the time it was
 * saved. Imported completions carry the source visit's date the same way.
 */
export function goalCompletionDate(goal: PatientGoalDetail): string | null {
  return goal.completed_on_task_date ?? goal.completed_date ?? null;
}

/** The completion status as the chart names it, or null for a goal still open. */
export function goalCompletionLabel(goal: PatientGoalDetail): string | null {
  if (goal.is_met) return 'Met';
  if (goal.is_unattainable) return 'Not attained';
  return null;
}
